// This must be the first line in src/index.js
import 'react-app-polyfill/ie9'

import React from 'react'
import ReactDOM from 'react-dom'
import initFonts from './fonts.js'
import './index.css'
import * as Sentry from '@sentry/browser'
import App from './App'
import * as serviceWorker from './serviceWorker'
import {BrowserRouter, Router, Route} from 'react-router-dom'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {SUPPRESS_DEV_ERROR_OVERLAY} from './keys'

// Initialize fonts early
initFonts();

if (window.location.hostname.toLowerCase() !== 'localhost') {
    Sentry.init({dsn: "https://dd4a2e03935849c6b8aedf1ff82f9297@sentry.io/1833996"})
} else if (process.env.NODE_ENV === 'development' && SUPPRESS_DEV_ERROR_OVERLAY) {
    // Suppress the CRA dev-mode error overlay (iframe) for client demos on localhost.
    // Toggle via SUPPRESS_DEV_ERROR_OVERLAY in keys.js.
    const hideOverlayStyle = document.createElement('style');
    hideOverlayStyle.innerHTML = `body > iframe[style*="z-index: 2147483647"] { display: none !important; }`;
    document.head.appendChild(hideOverlayStyle);
    try {
        // Also tell react-error-overlay to stop reporting, if available.
        // eslint-disable-next-line global-require
        require('react-error-overlay').stopReportingRuntimeErrors();
    } catch (e) { /* ignore if not installed */ }
}

const queryClient = new QueryClient();

ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
            <Route component={App}/>
        </BrowserRouter>
    </QueryClientProvider>
    ,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
